import { getCachedAnswer } from 'state/cache'

// A participated row's root post is a summary (parent_payload=summary). Caching it
// would replace the full cached post, and the answer cache drops fields a payload
// omits (bsv_upvalues, child_quests, ...). Seed the thread only when its root post
// is already cached in full, without the summary; otherwise opening the thread
// fetches it as it would cold.
export function questForCacheFromSummaryRow(quest: any) {
    const parentId = quest?.parent?.id ?? quest?.parent_id
    if (parentId == null || !getCachedAnswer(String(parentId))) return null
    const { parent: _summary, ...rest } = quest
    return { ...rest, parent_id: rest.parent_id ?? parentId }
}
